module.exports = __webpack_public_path__ + "img/ot5.c4cf6609.png";